import React, { useState, useEffect } from "react";
import TextField from "@material-ui/core/TextField";
import PremiumBadge from "./PremiumBadge.js";
import MaskedInput from "react-text-mask";

const TextMaskCustom = props => (
    <MaskedInput
        {...props}
        ref={props.inputRef}
        mask={[/\d/, /\d/, " ", /\d/, /\d/, " ", /\d/, /\d/, " ", /\d/, /\d/]}
        placeholderChar={"\u2000"}
    />
);

export default props => {
    const [text, setText] = useState("");
    const [error, setError] = useState('');

    const setNumber = (value) => {
        const val = value.replace(/\D/g, '').slice(0, props.maxLength || 100);
        setText(val);
    }
    const setCPRNumber = (value) => {
        let val = value.replace(/\D/g, '');//.slice(0, 10);
        // if (val.length > 6) {
        //     val = val.substr(0, 6) + '-' + val.substr(6);
        // }
        setError((!props.showError || val.length >= 6) ? '' : 'Fødselsdag skal være 6 cifre.');
        setText(val);
    }

    const setCPRLast4Digit = (value) => {
        let val = value.replace(/ /g, '');
        setError((!props.showError || val.length == 4) ? '' : 'De sidste 4 cifre i dit CPR nr skal bestå af 4 tegn.');
        setText(val);
    }

    useEffect(() => {
        setText(props.prop);
        if (props.type === 'cprLast4Digit' && props.prop.length == 4) {
            setError("");
        }
    }, [props.prop]);

    useEffect(() => {
        if (props.prop === text) return;
        const t = window.setTimeout(() => {
            if ((props.showError && text.length >= 6) || !props.showError || props.type !== 'cpr') props.changeValue(text);

        }, 300);
        return () => window.clearTimeout(t);
    }, [props, text]);
    return (
        <>
            {props.multiline === true ? (
                <div style={{ width: "100%" }}>
                    <TextField
                        label={props.text}
                        required={props.required}
                        id={props.id}
                        multiline
                        InputLabelProps={{ shrink: true }}
                        type={props.type || "text"}
                        value={text}
                        onChange={event => setText(event.target.value)}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        InputProps={{
                            endAdornment: props.disabled ? <PremiumBadge /> : ""
                        }}
                    />
                </div>
            ) : props.type === "phone" ? (
                <div style={{ width: "100%" }}>
                    <TextField
                        label={props.text}
                        InputLabelProps={{ shrink: true }}
                        type={props.type || "text"}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        InputProps={{
                            inputComponent: TextMaskCustom,
                            value: text,
                            onChange: event => setText(event.target.value),
                            endAdornment: props.disabled ? <PremiumBadge /> : ""
                        }}
                    />
                </div>
            ) : props.type === "number" ? (
                <div style={{ width: "100%" }}>
                    <TextField
                        id={props.id}
                        label={props.text}
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        value={text}
                        onChange={event => setNumber(event.target.value)}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        required={props.required}
                        InputProps={{
                            endAdornment: props.disabled ? <PremiumBadge /> : ""
                        }}

                        inputProps={{
                            maxLength: props.maxLength,
                        }}
                    />
                </div>
            ) : props.type === "cprLast6Digit" ? (
                <div style={{ width: "100%" }}>
                    <TextField
                        id={props.id}
                        label={props.text}
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        value={text}
                        onChange={event => setCPRNumber(event.target.value)}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        required={props.required}
                        InputProps={{
                            endAdornment: props.disabled ? <PremiumBadge /> : ""
                        }}

                        error={error !== ''}
                        helperText={error}

                        inputProps={{
                            minLength: 6,
                            maxLength: 6,
                        }}
                    />
                </div>
            ) : props.type === "cprLast4Digit" ? (
                <div style={{ width: "100%" }}>
                    <TextField
                        id={props.id}
                        label={props.text}
                        InputLabelProps={{ shrink: true }}
                        type="text"
                        value={text}
                        onChange={event => setCPRLast4Digit(event.target.value)}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        required={props.required}
                        InputProps={{
                            endAdornment: props.disabled ? <PremiumBadge /> : ""
                        }}

                        error={error !== ''}
                        helperText={error}

                        inputProps={{
                            minLength: 4,
                            maxLength: 4,
                        }}
                    />
                </div>
            ) : (
                props.required ? (<div style={{ width: "100%" }}>
                    <TextField
                        id={props.id}
                        label={props.text}
                        InputLabelProps={{ shrink: true }}
                        type={props.type || "text"}
                        value={text}
                        onChange={event => setText(event.target.value)}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        required={props.required}
                        InputProps={{
                            endAdornment: props.disabled ? <PremiumBadge /> : ""
                        }}

                        inputProps={{
                            maxLength: props.maxLength,
                        }}
                    />
                </div>):(
                <div style={{ width: "100%" }}>
                    <TextField
                        id={props.id}
                        label={props.text}
                        InputLabelProps={{ shrink: true }}
                        type={props.type || "text"}
                        value={text}
                        onChange={event => setText(event.target.value)}
                        style={{ margin: "10px auto 10px auto", width: "100%" }}
                        disabled={props.disabled || props.canEditData === false}
                        InputProps={{
                            endAdornment: props.disabled ? <PremiumBadge /> : ""
                        }}

                        inputProps={{
                            maxLength: props.maxLength,
                        }}
                    />
                </div>)
            )}
        </>
    );
};
